import rtEnv from '@mars/heroku-js-runtime-env';

export const compileEnv = process.env;
export const runtimeEnv = () => {
  return rtEnv();
};
